export default "__VITE_ASSET__d73bb795__"